const url = process.env.REACT_APP_API_BYGGDATA_BASE_URL + "api/user";

export interface IUserInfo {
    id: number,
    email: string,
    name: string
}

export default class User {
    private fetch: ((input: string, init?: RequestInit) => Promise<Response>)

    constructor(f: ((input: string, init?: RequestInit) => Promise<Response>)) {
        this.fetch = f;
    }

    public GetUserInfo = () => this.fetch(url)
        .then(r => r.json() as Promise<IUserInfo>)

    public GetAll = () => this.fetch(url + "/all")
        .then(r => r.json() as Promise<IUserInfo[]>)
}


// WEBPACK FOOTER //
// ./src/data/user.ts